<ng-container *ngIf="hasAccess">
<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <span class="mr-auto">
    <button mat-raised-button routerLink="/task-analyses-revised" class="m-1 mr-2">
      <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('ta-jsa-swms.list.account-title', 'TA/JSA/SWMS Templates') }}
    </button>

    <button *ngIf="urlPath == 'view' && canEdit" mat-raised-button routerLink="/task-analyses-revised/{{ ta_revised.id }}/edit" class="m-1 mr-2">
      <mat-icon>edit</mat-icon> Edit
    </button>
    <button *ngIf="urlPath == 'edit'" mat-raised-button routerLink="/task-analyses-revised/{{ ta_revised.id }}/view" class="m-1 mr-2">
      <mat-icon>visibility</mat-icon> View
    </button>

    <button *ngIf="canDelete" mat-raised-button (click)="onRemove()" color="warn" class="m-1 mr-2">
      <mat-icon>delete</mat-icon> Delete
    </button>
  </span>
</nav>

<mat-tab-group *ngIf="urlPath == 'edit'">
  <mat-tab label="Overview">
    <app-task-analyses-revised-edit [taTabsComponent]="this"></app-task-analyses-revised-edit>
  </mat-tab>
  <mat-tab *ngIf="ta_revised.id" [label]="utils.getLangTerm('ta-jsa-swms.fields.workflow_tab.label', 'Workflow')">
    <app-task-analyses-revised-workflows [taRevisedId]="ta_revised.id" [taRevisedPath]="urlPath"></app-task-analyses-revised-workflows>
  </mat-tab>
</mat-tab-group>

<app-task-analyses-revised-view *ngIf="urlPath == 'view'" [taTabsComponent]="this" [taRevisedId]="ta_revised.id"></app-task-analyses-revised-view>
</ng-container>
